var _path, _path2, _path3, _path4;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLeaderboard(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8881 11.7656H9.16602V20.9897H14.8881V11.7656Z",
    stroke: "#ACACB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6001 15.4697H14.8779V20.99H20.6001V15.4697Z",
    stroke: "#ACACB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16598 14.0166H3.44385V21.0002H9.16598V14.0166Z",
    stroke: "#ACACB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8184 9.62638C13.6012 9.6293 13.3888 9.56205 13.2129 9.43463L12.022 8.56672L10.8312 9.43463C10.657 9.55634 10.4487 9.61993 10.2362 9.61634C10.0237 9.61276 9.81778 9.54217 9.64775 9.41465C9.47773 9.28713 9.3523 9.10918 9.28935 8.90618C9.22641 8.70318 9.22916 8.48549 9.29721 8.28415L9.75135 6.89146L8.52013 6.02355C8.33212 5.903 8.1894 5.72348 8.11435 5.51313C8.0393 5.30277 8.03615 5.07346 8.10539 4.86113C8.17463 4.64879 8.31235 4.46542 8.49698 4.33974C8.68161 4.21406 8.90271 4.15318 9.12565 4.16663H10.589L11.0431 2.76385C11.0978 2.54564 11.2238 2.35195 11.4012 2.21356C11.5786 2.07517 11.7971 2 12.022 2C12.247 2 12.4655 2.07517 12.6429 2.21356C12.8202 2.35195 12.9463 2.54564 13.001 2.76385L13.4551 4.16663H14.9184C15.1414 4.15318 15.3625 4.21406 15.5471 4.33974C15.7317 4.46542 15.8694 4.64879 15.9387 4.86113C16.0079 5.07346 16.0048 5.30277 15.9297 5.51313C15.8547 5.72348 15.712 5.903 15.5239 6.02355L14.3432 6.89146L14.7973 8.28415C14.8524 8.44088 14.868 8.60878 14.8426 8.77295C14.8172 8.93713 14.7517 9.0925 14.6519 9.22529C14.552 9.35807 14.4209 9.46415 14.2703 9.53412C14.1196 9.60409 13.954 9.63578 13.7881 9.62638H13.8184ZM12.022 6.7199L12.5569 6.88137V6.30613L12.9 5.85199L12.3248 5.69052L12.022 5.2162L11.689 5.69052L11.1541 5.85199L11.4973 6.30613V6.88137L12.022 6.7199Z",
    fill: "#ACACB4"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeaderboard);
export default __webpack_public_path__ + "static/media/icon_leaderboard.60a27d4527463c7c79ae95e5f8d01780.svg";
export { ForwardRef as ReactComponent };